import api from '..'
import { CustomerProifle } from './types'
import { logger } from '../../utils/logger'

export const updateCustomerProfileFn = async (
  data: CustomerProifle
) => {
  try {
    const datata: Partial<CustomerProifle> = {
      name: data.name,
      email: data.email,
      phone: data.phone
    }

    if (data.password !== '' && data.passwordConfirm !== '') {
      datata.password = data.password
      datata.passwordConfirm = data.passwordConfirm
    }

    const response = await api.patch('auth/customer/profile', datata)
    return response.data
  } catch (error) {
    logger.logError(error instanceof Error ? error : new Error('Update profile error'), {
      type: 'update_profile_error',
      email: data.email
    })
    throw error
  }
}
